export const LOGO_URL =
  "https://static.prod-images.emergentagent.com/jobs/89593136-9f90-4eeb-a4b8-71ebd3ba44b5/images/b99299454da79d5a2e442afffe176e387702d03b7e146c62d34318a12848fe55.jpeg";

export const HERO_IMG =
  "https://static.prod-images.emergentagent.com/jobs/89593136-9f90-4eeb-a4b8-71ebd3ba44b5/images/4cd47d2ac40f9c21b4bf383da402df7bcbae3a9e4650c0d34ad659974d780197.jpeg";

export const TAGLINE = "Votre véhicule, notre passion !";

export const VEHICLE_TYPES = [
  { id: "citadine", label: "Citadine" },
  { id: "berline", label: "Berline" },
  { id: "suv", label: "SUV / 4x4" },
  { id: "six", label: "6 places ou +" },
];

export const FORMULES = [
  {
    id: "silver",
    apiKey: "SILVER",
    name: "Formule Silver",
    accent: "#9aa4ad",
    prices: { citadine: 50, berline: 60, suv: 70, six: 80 },
    exterieur: [
      "Pré-lavage à la main",
      "Nettoyage surfaces / vitres",
      "Nettoyage jantes + séchage",
      "Nettoyage contour / portes",
    ],
    interieur: [
      "Aspiration habitacle",
      "Dépoussiérage habitacle",
      "Brillance plastiques",
      "Nettoyage surfaces / vitres",
      "Aspiration coffre",
    ],
  },
  {
    id: "gold",
    apiKey: "GOLD",
    name: "Formule Gold",
    accent: "#e2b455",
    popular: true,
    prices: { citadine: 90, berline: 100, suv: 120, six: 140 },
    exterieur: [
      "Pré-lavage à la main",
      "Nettoyage surfaces / vitres",
      "Nettoyage jantes + séchage",
      "Nettoyage contour / coffre",
      "Application brillance pneu",
    ],
    interieur: [
      "Aspiration habitacle",
      "Dépoussiérage",
      "Brillance plastiques",
      "Nettoyage surfaces / vitres",
      "Aspiration coffre",
      "Pressing tissu, sol & tapis",
      "Traitement cuir / alcantara",
      "Désinfectant habitacle",
    ],
  },
  {
    id: "platinum",
    apiKey: "PLATINUM",
    name: "Formule Platinum",
    accent: "#d8dde2",
    prices: { citadine: 270, berline: 300, suv: 330, six: 370 },
    exterieur: [
      "Pré-lavage à la main",
      "Nettoyage surfaces / vitres",
      "Nettoyage jantes + séchage",
      "Nettoyage contour / portes",
      "Application brillance pneu",
      "Dégoudronnage",
      "Cire de protection",
      "Polish",
    ],
    interieur: [
      "Aspiration habitacle",
      "Dépoussiérage habitacle",
      "Brillance plastiques",
      "Nettoyage surfaces / vitres",
      "Aspiration coffre",
      "Pressing tissu, sol & tapis",
      "Traitement cuir / alcantara",
      "Désinfectant habitacle",
    ],
  },
];

export const MOTO = { apiKey: "MOTO", name: "Lavage spécial moto", price: 35 };

export const OPTIONS = [
  { label: "Rénovation optiques", price: 60 },
  { label: "Nettoyage moteur", price: 15 },
  { label: "Nettoyage ciel de toit", price: 15 },
  { label: "Dégoudronnant", price: 15 },
  { label: "Poils de chien", price: 15 },
];

export const OFFERED =
  "Niveau du liquide de refroidissement, lave-glace et pression des pneus offerts. Tarifs à partir de, selon l'état du véhicule.";

export const GALLERY = [
  {
    label: "Carrosserie",
    before:
      "https://images.unsplash.com/photo-1770935883781-a2f5a52b69da?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    after:
      "https://images.unsplash.com/photo-1611651186486-415f04eb78e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    label: "Habitacle",
    before:
      "https://images.unsplash.com/photo-1698034303047-92ce45252796?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    after:
      "https://images.unsplash.com/photo-1549064233-945d7063292f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  },
  {
    label: "Finition",
    before:
      "https://images.pexels.com/photos/6872609/pexels-photo-6872609.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400",
    after:
      "https://images.pexels.com/photos/10182852/pexels-photo-10182852.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1400",
  },
];

export const REVIEWS = [
  {
    text: "Voiture récupérée quasi neuve. Aucune trace, plus aucune odeur. Une équipe sérieuse et hyper minutieuse.",
    name: "Johanna A.",
    role: "Peugeot 3008",
  },
  {
    text: "La formule Platinum vaut chaque centime. La carrosserie brille comme au premier jour. Je recommande +++.",
    name: "Seb G.",
    role: "BMW Série 3",
  },
  {
    text: "Accueil parfait, travail rapide et impeccable. C'est devenu mon rendez-vous mensuel obligatoire.",
    name: "Laura F.",
    role: "Audi A1",
  },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "L'Exigence",
    text: "Chaque véhicule est traité comme une pièce unique. Diagnostic complet, produits pro sélectionnés, et un souci du détail qui ne laisse rien au hasard.",
  },
  {
    n: "02",
    title: "Le Matériel",
    text: "Haute pression, vapeur écologique, polisseuses rotatives et microfibres premium. Un équipement de niveau professionnel pour un résultat sans compromis.",
  },
  {
    n: "03",
    title: "Le Résultat",
    text: "Une brillance profonde, un habitacle sain et une protection durable. Vous repartez avec une voiture transformée, prête à traverser Marseille avec style.",
  },
];

export const CONTACT = {
  address: "33 rue Montolieu, 13002 Marseille",
  phone: "07 71 46 39 29",
  phoneRaw: "0771463929",
  hours: "9h – 18h · Lundi au Samedi",
};
